import {FC} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../modules/auth'
import {actingShopBranch, canChooseBranch} from '../modules/common/actingBranch'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

/**
 * Mart v2: "Apply to all branches" on a price, discount or on/off edit. Without it the edit reaches
 * only the branch picked in the header bar. Shown only to an all-branches user of a supplier with
 * several shops — the server refuses it for a user tied to a branch anyway.
 */
const AllBranchesCheckbox: FC<Props> = ({checked, onChange, disabled}) => {
  const {formatMessage} = useIntl()
  const {currentUser} = useAuth()
  const acting = actingShopBranch(currentUser)
  if (!canChooseBranch(currentUser) || !acting) {
    return null
  }

  return (
    // Inset from both sides so the box and its help text never touch a window's edge (user ask 2026-11-01).
    <div className='form-check my-3 mx-3'>
      <input
        id='apply-to-all-branches'
        type='checkbox'
        className='form-check-input'
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <label className='form-check-label fw-semibold' htmlFor='apply-to-all-branches'>
        {formatMessage({id: 'branch.apply_to_all'})}
      </label>
      <div className='form-text'>
        {formatMessage(
          {id: 'branch.apply_to_all_help'},
          {branch: acting.branch_name || acting.name}
        )}
      </div>
    </div>
  )
}

export default AllBranchesCheckbox
